import * as React from 'react';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styled from '@emotion/styled';
import EditIconWithBox from '../../assets/svg/EditIconWithBox';
import { Button, Grid, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GoPrimitiveDot } from 'react-icons/go';
import DateRange from '../Dashboard/DateRange';
import moment from 'moment';
import {
  useGetDashboardGanttCharts,
  useGetDashboardGanttChartsHC,
} from '../../hooks/dashboardHooks';
interface PropI {
  Component?: any;
  data?: any;
  title: string;
  height?: string;
  isEditIcon?: boolean;
  isViewAll?: boolean;
  isChart?: boolean;
  isGrant?: boolean;
  isGrantSF?: boolean;
  isMutliCol?: boolean;
  viewAllLink?: string;
}
const CardHead = (props: PropI) => {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.only('md'));
  const {
    Component,
    data,
    title,
    height,
    isEditIcon = false,
    isViewAll = false,
    isChart = false,
    isGrant = false,
    isGrantSF = false,
    isMutliCol = false,
    viewAllLink = '',
  } = props;
  const CardWrapper = styled(Box)(() => ({
    padding: '18px 14px',
    boxShadow: '0px 2px 10px rgba(40, 40, 40, 0.1)',
    borderRadius: '15px',
    '.card-header': {
      position: 'sticky',
      // top: '0',
      zIndex: '2',
      height: isGrant || isGrantSF ? (isMdScreen ? '100px' : '40px') : '40px',
      alignItems: 'center',
    },
    '.header-box': {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'center',
      flexWrap: 'wrap',
    },
    '.card-block': {
      // marginTop: '20px',
      height: height,
      overflow: !isChart ? 'auto' : isGrant ? 'auto' : 'hidden',
    },
    // height: height,
    //marginBottom: '18px',
    //width: '427px',
    // padding: '18px 14px',
    // overflow: !isChart ? 'auto' : 'hidden',
    '.MuiCardContent-root': {
      padding: '0px',
    },
    '.MuiCardContent-root:last-child': {
      paddingBottom: '0px',
    },
    '.heading-wrapper': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '10px',
    },
    '.head-title': {
      color: '#265AA8',
      fontWeight: 700,
      fontSize: '21px',
    },
    '.view-link': {
      color: '#265AA8',
      fontWeight: 600,
      fontSize: '14px',
      cursor: 'pointer',
    },
    '.grant-button': {
      marginRight: '10px',
      border: '1px solid #D2D1D1',
      color: '#242424',
      textTransform: 'none',
      borderRadius: '8px',
      marginTop: isGrant || isGrantSF ? (isMdScreen ? '10px' : '0px') : '0px',
    },
  }));

  const navigate = useNavigate();
  const currentDate: any = moment();
  const weekStart = currentDate.clone().startOf('week');
  const weekEnd = currentDate.clone().endOf('week');
  const [ganttDates, setGranttDatesState] = React.useState({
    startDate: moment(weekStart).format('YYYY-MM-DD'),
    endDate: moment(weekEnd).format('YYYY-MM-DD'),
  });
  const { data: dashboardGanttCharts } = useGetDashboardGanttChartsHC(true, {
    startDate: ganttDates.startDate,
    endDate: ganttDates.endDate,
  });
  const WorkorderStatus = dashboardGanttCharts;
  const setGranttDates = (e, { startDate, endDate }) => {
    setGranttDatesState({
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    });
  };
  //Gantt Dates SF
  const [ganttDatesSF, setGranttDatesStateSF] = React.useState({
    startDate: moment(weekStart).format('YYYY-MM-DD'),
    endDate: moment(weekEnd).format('YYYY-MM-DD'),
  });
  const { data: dashboardGanttChartsSF } = useGetDashboardGanttCharts(true, {
    startDate: ganttDatesSF.startDate,
    endDate: ganttDatesSF.endDate,
  });
  const WorkorderStatusSF = dashboardGanttChartsSF;
  const setGranttDatesSF = (e, { startDate, endDate }) => {
    setGranttDatesStateSF({
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    });
  };
  return (
    <CardWrapper>
      <Box className='card-header heading-wrapper'>
        <Box className='header-box'>
          <Box display={'flex'}>
            <Box>
              <Typography className='head-title'>
                {title}
                {/* {isEditIcon && <EditIconWithBox />} */}
              </Typography>
            </Box>
            {isGrant && (
              <Box mx={1}>
                <DateRange
                  setDatesState={setGranttDatesState}
                  dates={ganttDates}
                  setDates={setGranttDates}
                />
              </Box>
            )}
            {isGrantSF && (
              <Box mx={1}>
                <DateRange
                  setDatesState={setGranttDatesState}
                  dates={ganttDatesSF}
                  setDates={setGranttDatesSF}
                />
              </Box>
            )}
          </Box>

          {(isGrant || isGrantSF) && (
            <Box>
              <Button variant='outlined' className='grant-button'>
                <GoPrimitiveDot color={'#93CE16'} fontSize={'28px'} />
                Ontime ({WorkorderStatus?.onTimeCount})
              </Button>
              <Button variant='outlined' className='grant-button'>
                <GoPrimitiveDot color={'#F29E38'} fontSize={'28px'} />
                Delayed ({WorkorderStatus?.delayCount})
              </Button>
              <Button variant='outlined' className='grant-button'>
                <GoPrimitiveDot color={'#CC0000'} fontSize={'28px'} />
                Needs attention ({WorkorderStatus?.needAttentionCount})
              </Button>
            </Box>
          )}

          {isViewAll && (
            <Box
              onClick={() => {
                viewAllLink && navigate(viewAllLink);
              }}
              className='view-link'
            >
              View All
            </Box>
          )}
        </Box>
      </Box>
      <CardContent>
        <Box className='card-block'>
          {!isChart &&
            !isMutliCol &&
            data?.map((currentCard: any, ind: number) => {
              return <Component key={ind} cardData={currentCard} />;
            })}
          {!isChart && isMutliCol && (
            <Grid container spacing={2}>
              {data?.map((currData: any, ind: React.Key | null | undefined) => {
                return (
                  <Grid item xs={6} key={ind}>
                    <Component />
                  </Grid>
                );
              })}
            </Grid>
          )}
          {isGrant && (
            <Grid container spacing={2}>
              <Grid item xs={12} key={'ind'}>
                <Component cardData={dashboardGanttCharts} dates={ganttDates} />
              </Grid>
            </Grid>
          )}
          {isGrantSF && (
            <Grid container spacing={2}>
              <Grid item xs={12} key={'ind'}>
                <Component cardData={dashboardGanttChartsSF} dates={ganttDatesSF} />
              </Grid>
            </Grid>
          )}
          {isChart && (
            <Component
              isEditBtn={
                ![
                  'Top Downtimes',
                  'TAT of Workers',
                  'Scrap Generations',
                  // 'Production Count',
                ].includes(title)
              }
            />
          )}
        </Box>
      </CardContent>
    </CardWrapper>
  );
};

export default CardHead;
